import React from 'react';
import styled from 'styled-components';
import format from 'date-fns/format';
import compareDesc from 'date-fns/compareDesc';
import LoadingCube from 'sub_components/Common/LoadingCube';
import isValid from 'date-fns/isValid';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import { array, bool, string, func } from 'prop-types';
//import { BloxButton } from 'styled_components/Common/BloxButton';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const unviewedDefaultDownloadCloud = `${CDN_URL}common/download-cloud-icon-default-unviewed.svg`;
const filepdf = `${CDN_URL}common/file-pdf.svg`;

const Documents = styled.div`
	display: flex;
	width: 100%;
	height: 500px;

	color: ${props => props.theme.defaultFontColor};
	.ScrollbarsCustom-Track {
		right: 56px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.account} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}

	.documents-wrapper {
		display: flex;
		width: 100%;
		height: 100%;
		flex-wrap: wrap;
		position: relative;
		margin-bottom: 100px;

		.top-section {
			padding-top: 6px;
			padding-left: 6px;
			padding-right: 6px;
			height: 40px;
			img {
				width: 20px;
				height: 20px;
			}
		}
		.title-wrapper {
			display: flex;
			align-items: flex-start;
			height: 33px;
			.title {
				font-size: 11px;
			}
		}
		.divider {
			position: absolute;
			top: 39px;
			left: 6px;
			width: 96px;
			height: 2px;
			border-radius: 15px;
			background-color: ${props => props.theme.Cool_Gray_Light_3};
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.boxShadow} inset;
		}
		.bottom-section {
			padding: 6px;
			position: relative;
			height: 72px;
			.date {
				display: flex;
				align-items: center;
				color: ${props => props.theme.defaultFontColor};
				.value {
					margin-left: 10px;
					margin-top: 2px;
				}
			}
			.icon {
				position: absolute;
				right: 8px;
				bottom: 15px;
				img {
					width: 20px;
					height: 20px;
				}
			}
		}
		.document {
			width: 112px;
			height: 145px;
			margin-right: 16px;
			margin-bottom: 23px;
			cursor: pointer;
			.title {
			}
			.card {
				position: relative;
				height: 112px;
				box-shadow: 2px 2px 4px 0 ${props => props.theme.boxShadow};
				border-radius: 0px;
				background-color: ${props => props.theme.white};
			}
			&.disabled {
				pointer-events: none;
				opacity: 0.5;
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 700px;
		.ScrollbarsCustom-Track {
			right: 83px !important;
			top: 0px !important;
		}

		.ScrollbarsCustom-ThumbY {
			width: 8px !important;
		}
		.ScrollbarsCustom-TrackY {
			width: 8px !important;
		}

		.documents-wrapper {
			.top-section {
				padding-top: 16px;
				padding-left: 16px;
				padding-right: 16px;
				height: 56px;
			}
			.divider {
				top: 56px;
				left: 8px;
				width: 144px;
				height: 2px;
				box-shadow: -1px -1px 1.5px ${props =>
					props.theme.Cool_Gray_Light_3}  inset, 1px 1px 1.5px ${props =>
					props.theme.boxShadow}2) inset;
			}
			.title-wrapper {
				height: 56px;
				.title {
					font-size: 14px;
				}
			}
			.bottom-section {
				padding: 16px;
				position: relative;
				height: 102px;

				.date {
					display: flex;
					align-items: center;
					color: ${props => props.theme.defaultFontColor};
					.value {
						margin-left: 10px;
						margin-top: 1px;
					}
				}
				.icon {
					position: absolute;
					right: 16px;
					bottom: 10px;
					img {
						width: 20px;
						height: 20px;
					}
				}
			}
			.document {
				width: 160px;
				height: 216px;
				margin-right: 32px;
				margin-bottom: 23px;

				.card {
					height: 160px;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 900px !important;
		.ScrollbarsCustom-Track {
			right: 143px !important;
			top: 0px !important;
		}

		.ScrollbarsCustom-ThumbY {
			width: 10px !important;
		}
		.ScrollbarsCustom-TrackY {
			width: 10px !important;
		}

		.documents-wrapper {
			.top-section {
				padding-top: 24px;
				padding-left: 24px;
				padding-right: 24px;
				height: 96px;
			}
			.divider {
				top: 96px;
				left: 12px;
				width: 244px;
				height: 2px;
				box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
					1px 1px 1.5px ${props => props.theme.boxShadow} inset;
			}
			.title-wrapper {
				height: 96px;
				.title {
					font-size: 16px;
				}
			}
			.bottom-section {
				padding: 24px;
				position: relative;
				min-height: 175px;

				.date {
					display: flex;
					align-items: center;
					color: ${props => props.theme.defaultFontColor};
					.value {
						margin-left: 24px;
						margin-top: 1px;
					}
				}
				.icon {
					position: absolute;
					right: 24px;
					bottom: 10px;
					img {
						width: 30px;
						height: 30px;
					}
				}
			}
			.document {
				width: 272px;
				height: 336px;
				margin-right: 48px;
				margin-bottom: 40px;
				.card {
					height: 272px;
				}
			}
		}
	}
`;
function sortReleases(releases) {
	const sortedReleases =
		releases &&
		releases.sort((a, b) => compareDesc(new Date(a.publish_date), new Date(b.publish_date)));
	return sortedReleases;
}

export const DocumentsDisplay = ({
	data,
	onClick,
	viewing,
	releases,
	isLoading,
	hasDownloadDocumentAccess,
	sendingDocument,
}) => {
	const sortedReleases = sortReleases(releases);

	return (
		<Documents>
			{isLoading && <LoadingCube />}
			<ScrollView>
				<div className='documents-wrapper'>
					{data &&
						viewing !== 'releases' &&
						data.map(driveItem => {
							const driveName = driveItem?.name;
							const createdDateTime = new Date(driveItem?.createdDT);
							if (driveItem?.isFolder || driveName.startsWith('.')) {
								return '';
							} else {
								return (
									<div
										className={sendingDocument ? 'document disabled' : 'document'}
										id={`download-button-wrapper${driveItem?.name}`}
									>
										<div className='title-wrapper'>
											<div className='title body10'>{`${driveItem?.name}.`}</div>
										</div>
										<div
											className='card'
											onClick={hasDownloadDocumentAccess ? () => onClick(driveItem) : () => {}}
										>
											<div className='top-section'>
												<div className='pdf-icon-wrapper'>
													<img src={filepdf} className='pdf-icon' />
												</div>
											</div>
											<div className='divider'></div>
											<div className='bottom-section'>
												<div className='date'>
													<div className='label labels21'>Date</div>
													<div className='value body10'>
														{isValid(createdDateTime) ? format(createdDateTime, 'MM dd yyyy') : ''}
													</div>
												</div>
												<div className='icon'>
													<img id={`download-button-`} src={unviewedDefaultDownloadCloud} />
												</div>
											</div>
										</div>
									</div>
								);
							}
						})}
					{viewing === 'releases' &&
						sortedReleases &&
						sortedReleases.map(release => {
							const version = release.version.split(' ').join('');
							const href = hasDownloadDocumentAccess
								? `/cdn/release/${version}.pdf`
								: () => {
										return false;
								  };
							return (
								<div
									className={sendingDocument ? 'document disabled' : 'document'}
									id={`download-button-wrapper${release.version}`}
								>
									<div className='title-wrapper'>
										<div className='title body10'>{`Portal Release. Version: ${version}.`}</div>
									</div>
									<div className='card'>
										<a href={href} download={`${version}.pdf`}>
											<div className='top-section'>
												<div className='pdf-icon-wrapper'>
													<img src={filepdf} className='pdf-icon' />
												</div>
											</div>
											<div className='divider'></div>
											<div className='bottom-section'>
												<div className='date'>
													<div className='label labels21'>Date</div>
													<div className='value body10'>{release?.publish_date}</div>
												</div>
												<div className='icon'>
													<img id={`download-button-`} src={unviewedDefaultDownloadCloud} />
												</div>
											</div>
										</a>
									</div>
								</div>
							);
						})}
				</div>
			</ScrollView>
		</Documents>
	);
};
DocumentsDisplay.propTypes = {
	data: array,
	onClick: func,
	viewing: string,
	releases: array,
	isLoading: bool,
	hasDownloadDocumentAccess: bool,
	sendingDocument: bool,
};

DocumentsDisplay.defaultProps = {
	onClick: () => {},
	hasDownloadDocumentAccess: false,
	data: null,
	viewing: 'General',
	releases: null,
	isLoading: true,
	sendingDocument: false,
};
